import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  activeFilters: {
    cityIds: [],
    isTest: false,
    isLocalitySupported: true,
    zone_supported: false,
    zone_unsupported: false,
    show_type: "locality",
  },
  localitiesList: [],
  zonesList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_ACTIVE_FILTERS_BOUNDARIES:
      return setActiveFilters(state, action);
    case ActionTypes.RESET_BOUNDARIES_STATE:
      return resetState(state, action);
    case ActionTypes.SET_GEO_BOUNDARIES:
      return setGeoBoundaries(state, action);
    default:
      return state;
  }
}

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const setGeoBoundaries = (state, action) => {
  return {
    ...state,
    localitiesList: getPath(action.payload, "locality.boundaries", []),
    zonesList: getPath(action.payload, "zone.boundaries", []),
  };
};

const resetState = (state, action) => {
  // reset specific key if given else reset complete state
  if (action.payload.state) {
    return {
      ...state,
      [action.payload.state]: getInitialState(
        initialState,
        action.payload.state
      ),
    };
  } else {
    return initialState;
  }
};
